import React, { useEffect } from "react";
import { useForm } from "react-hook-form";

function HookForm(props) {
  const { onSubmit, init, defaultForm, children } = props;

  /**
   * Initializes a form using the useForm hook from the react-hook-form library.
   * @param {Object} props - The props object containing the default form values.
   * @param {Object} defaultForm - The default values for the form.
   * @returns An object containing the form methods and state.
   */
  const method = useForm({
    mode: "onChange",
    defaultValues: defaultForm,
    criteriaMode: "all",
  });

  /**
   * Runs the init function with the given method when the component mounts or when the init or method
   * dependencies change.
   * @param {Function} init - The initialization function to run.
   * @param {string} method - The method to pass to the initialization function.
   * @returns None
   */
  useEffect(() => {
    init && init(method);
  }, [init, method]);

  return (
    <form onSubmit={method.handleSubmit(onSubmit)}>{children(method)}</form>
  );
}

HookForm.defaultProps = {
  defaultValues: {},
  onSubmit: () => {},
};
export default HookForm;
